import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ApiCall } from "../../utils/api";

const initialState = {
  user: {},
  userDetails: {},
  registerUser: {},
  loading: false,
  registerLoading: false,
  countries: [],
  jobtitles: [],
};

export const getRegisterUser = createAsyncThunk(
  "adminconsole/getRegisterUser",
  async (params) => {
    const response = await ApiCall(
      "GET",
      "",
      "/admin/user/registration/details/get",
      params,
      true
    );
    if (response?.data?.code === 200) {
      return response?.data?.data;
    } else if (response?.data?.code === 204) {
      return response?.data?.data;
    } else {
      toast.error(response?.data?.message);
      return null;
    }
  }
);

export const getUser = createAsyncThunk(
  "adminconsole/getuser",
  async (params) => {
    const response = await ApiCall(
      "GET",
      "",
      "/admin/user/details/get",
      params
    );
    return response.data.data;
  }
);

export const addUser = createAsyncThunk(
  "adminconsole/adduser",
  async (body) => {
    const response = await ApiCall(
      "POST",
      body,
      "/admin/user/register",
      "",
      true
    );

    return response.data;
  }
);

export const getCountries = createAsyncThunk(
  "adminconsole/countries",
  async (params) => {
    const response = await ApiCall(
      "GET",
      "",
      "/admin/country/get",
      params,
      true
    );
    return response.data.data;
  }
);

export const getJobTitles = createAsyncThunk(
  "adminconsole/jobtitles",
  async (params) => {
    const response = await ApiCall("GET", "", "/admin/jobtitle/get", params);
    return response.data.data;
  }
);

export const registerSlice = createSlice({
  name: "adminconsole",
  initialState,
  extraReducers: {
    [getUser.pending]: (state) => {
      state.loading = true;
    },
    [getUser.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.user = payload;
    },
    [getUser.rejected]: (state) => {
      state.loading = false;
    },
    [addUser.pending]: (state) => {
      state.registerLoading = true;
    },
    [addUser.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.userDetails = payload;
      } else {
        state.userDetails = {};
      }
      state.registerLoading = false;
    },
    [addUser.rejected]: (state) => {
      state.registerLoading = false;
    },
    [getCountries.pending]: (state) => {},
    [getCountries.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.countries = payload;
      } else {
        state.countries = [];
      }
    },
    [getCountries.rejected]: (state) => {},
    [getJobTitles.pending]: (state) => {},
    [getJobTitles.fulfilled]: (state, { payload }) => {
      if (payload) state.jobtitles = payload;
      else state.jobtitles = [];
    },
    [getJobTitles.rejected]: (state) => {},
    [getRegisterUser.pending]: (state) => {
      state.loading = true;
    },
    [getRegisterUser.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.registerUser = payload;
    },
    [getRegisterUser.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const registerReducer = registerSlice.reducer;
